import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ngxui-taskpane-user-menu',
  templateUrl: './taskpane-user-menu.component.html',
  styleUrls: ['./taskpane-user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskpaneUserMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
